import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';

class FormController {
    constructor() {
        FormController.doAll();
    }
	
    static get INPUT_SELECTOR() {
        return '.sos-form.sos-md input[type=text], .sos-form.sos-md input[type=email], .sos-form.sos-md input[type=tel], .sos-form.sos-md textarea, .sos-md2-form input[type=text], .sos-md2-form input[type=email], .sos-md2-form input[type=tel], .sos-md2-form input[type=password], .sos-md2-form input[type=number], .sos-md2-form textarea';
    }
    static get SELECT_SELECTOR() {
        return '.sos-form.sos-md select, .sos-md2-form select';
    }

    static get TOOLTIP_SELECTOR() {
        return '.sos-tool-tip';
    }

    static initTooltip(){
        //https://atomiks.github.io/tippyjs/v6/constructor/
        tippy(this.TOOLTIP_SELECTOR,{
            arrow: false,
            allowHTML: true,
            theme: 'light-border',
            //hideOnClick: "toggle",
            //trigger: "click",
            content(reference) {
                let titleDiv = '';
                const title = reference.getAttribute('data-title');
                if(title){
                    titleDiv = `<div class='title'>${title}</div>`
                }

                const content = reference.getAttribute('data-content');
                
                return `${titleDiv}<div class='content'>${content}</div>`;
            },
        });

        //this.hideTooltipOnScroll();
    }

    static hideTooltipOnScroll(){
        document.addEventListener('scroll', () => {
            hideAll({duration: 0});
        })
    }

    static doAll() {
        FormController.toggleInputState();
        FormController.toggleSelectClass();
        FormController.initTooltip();
    }

    static toggleInputState() {
        document.querySelectorAll(this.INPUT_SELECTOR).forEach(function (item) {
            if (item.value !== '')
                item.classList.add('has-value');
            else
                item.classList.remove('has-value');
            item.addEventListener('change', function (event) {
                const elem = event.currentTarget;
                if (elem.value !== '')
                    elem.classList.add('has-value');
                else
                    elem.classList.remove('has-value');
            });
        });
    }

    static toggleSelectClass() {
        document.querySelectorAll(this.SELECT_SELECTOR).forEach(function (item) {
            if (item.options[item.options.selectedIndex] != null && item.options[item.options.selectedIndex].value.length > 0
                && item.options[item.options.selectedIndex].value !== '-1' && item.options[item.options.selectedIndex].text.length > 0)
                item.classList.add('has-value');
            item.addEventListener('change', function (event) {
                const elem = event.currentTarget;
                if (elem.options[elem.options.selectedIndex] != null && elem.options[elem.options.selectedIndex].value.length > 0
                    && elem.options[elem.options.selectedIndex].value !== '-1' && elem.options[elem.options.selectedIndex].text.length > 0)
                    elem.classList.add('has-value');
                else
                    elem.classList.remove('has-value');
            });
        });
    }

    static init() {
        document.addEventListener("DOMContentLoaded", () => {
            if(document.querySelector('.sos-form.sos-md, .sos-md2-form') !== null)
                new FormController();
        });
    }
}

window.FormController = FormController;
export default FormController;
